query WfaSessionSummary($runId: ConditionID!) {
	wfa_session_runs(run_id_eq: $runId) {
		total_pages
		total_issues
	}
	wfa_session_components_runs(run_id_eq: $runId) {
		component_id_count
	}
}
